export default {
    FIRST_IMAGE: 'assets/images/nam-san-home.jpg'
}
